<script setup lang="ts">
import Modal from "@/Components/Modal.vue";
import {ref} from "vue";
import RobloxInstructiionAccordion from "@/Components/RobloxInstructiionAccordion.vue";

defineProps<{
    isOpen: boolean;
}>();
defineEmits<{
    (e: 'onToggle', payload: boolean): void
}>()

// 0 - Инструкция для ПК
// 1 - Инструкция для телефона
const mode = ref(1);
</script>

<template>
    <Modal :show="isOpen" max-width="2xl" modalClass="h-[90dvh]">
        <div class="py-5 px-3 flex flex-col gap-3 bg-slate-200 z-20 h-full">
            <div class="w-full flex justify-between pb-6 border-dashed border-black border-b">
                <div class="flex">
                    <button class="uppercase py-2 w-[115px] flex justify-center rounded-l-full font-sans font-medium text-sm border border-black"
                            :class="[mode === 1 ? 'bg-black text-white' : 'text-slate-500 bg-transparent']"
                            @click="mode = 1">
                        {{$t("phone")}}
                    </button>
                    <button class="uppercase text-slate-500 py-2 w-[115px] flex justify-center rounded-r-full font-sans font-medium text-sm border border-black"
                            :class="[mode === 0 ? 'bg-black text-white' : 'text-slate-500 bg-transparent']"
                            @click="mode = 0">
                        {{$t("PC")}}
                    </button>
                </div>
                <button @click="$emit('onToggle', true)" class="bg-transparent border-none outline-hidden">
                    <img src="/assets/img/roblox/close-modal.svg" alt="close-modal">
                </button>
            </div>
            <div class="gamepass-instruction" v-if="mode === 1">
                <h2>
                    {{$t('Manual: how to create a Game Pass in Roblox and set a price for it.')}}
                </h2>
                <p v-html="$t('Log in to your Roblox account on the website and select <strong>Create<strong> at the top.')"></p>
                <img src="/assets/img/roblox/instruction/mobile/1.webp" alt="1">
                <p v-html="$t('If you\'re in the Roblox app on your phone, tap <strong>More</strong> on the bottom right.')"></p>
                <img src="/assets/img/roblox/instruction/mobile/2.webp" alt="2">
                <p v-html="$t('Then find the button that says <strong>Create</strong> and click on it.')"></p>
                <img src="/assets/img/roblox/instruction/mobile/3.webp" alt="3">
                <p>{{$t('Next, everything is the same on both the website and app.')}}</p>
                <p v-html="$t('Click on the <strong>3 bars at the top left</strong> and choose <strong>Creations</strong> from the drop down menu.')"></p>
                <img src="/assets/img/roblox/instruction/mobile/4.webp" alt="4">
                <p v-html="$t('Next you need to select the Place in which to make the Game Pass. Make sure your Place is public - there\'s a green sign that says <strong>Public<strong>.')"></p>
                <img src="/assets/img/roblox/instruction/mobile/5.webp" alt="5">
                <RobloxInstructiionAccordion class="mb-5">
                    <template #question>
                        {{$t('Click here if you have it says Private instead of Public.')}}
                    </template>
                    <template #answer>
                        <p v-html="$t('If it says Private under the name of the Place, click on the <strong>circle with 3</strong> dots in the upper right corner of the Place picture.')">
                        </p>
                        <img src="/assets/img/roblox/instruction/mobile/6.webp" alt="6">
                        <p v-html="$t('In the drop down menu, click <strong>Make Public</strong>.')"></p>
                        <img src="/assets/img/roblox/instruction/mobile/7.webp" alt="7">
                    </template>
                </RobloxInstructiionAccordion>
                <p v-html="$t('If it says Public under the Place’s name, click on the <strong>Place<strong> itself.')"></p>
                <img src="/assets/img/roblox/instruction/mobile/8.webp" alt="8">
                <p v-html="$t('Click on the <strong>3 bars at the top left</strong> and in the drop down menu choose <strong>Monetization</strong>.')"></p>
                <img src="/assets/img/roblox/instruction/mobile/9.webp" alt="9">
                <p v-html="$t('Next click <strong>Passes</strong>.')"></p>
                <img src="/assets/img/roblox/instruction/mobile/10.webp" alt="10">
                <p v-html="$t('Next click <strong>Create A Pass</strong>.')"></p>
                <img src="/assets/img/roblox/instruction/mobile/11.webp" alt="11">
                <p v-html="$t('Then enter any name of the pass in the <strong>Name</strong> field. It is not necessary to fill in the Description field. And click <strong>Create Pass</strong>.')"></p>
                <img src="/assets/img/roblox/instruction/mobile/12.webp" alt="12">
                <p v-html="$t('In the list of your gamepasses find the created pass. And click <strong>on it</strong>.')"></p>
                <img src="/assets/img/roblox/instruction/mobile/13.webp" alt="13">
                <p v-html="$t('Click on the <strong>3 bars at the top left</strong> and select <strong>Sales</strong> from the drop down menu.')"></p>
                <img src="/assets/img/roblox/instruction/mobile/14.webp" alt="14">
                <p v-html="$t('Toggle the <strong>Item for Sale</strong> slider to turn blue, and under the Default Price field, be sure to uncheck <strong>Enable regional pricing</strong>.')"></p>
                <img src="/assets/img/roblox/instruction/mobile/15.webp" alt="15">
                <p v-html="$t('In the <strong>Default Price</strong> field, set the price we specified and click <strong>Save Changes</strong>.')"></p>
                <img src="/assets/img/roblox/instruction/mobile/16.webp" alt="16">
                <p v-html="$t('Basically, everything is ready. But you can double-check yourself: in the list of your passes for the created pass, check the <strong<Current Price</strong>, and in the <strong<Regional Pricing</strong< column it should be Disabled.')"></p>
                <img src="/assets/img/roblox/instruction/mobile/17.webp" alt="17">
                <p>{{$t(`That's it for sure now!`)}}</p>
                <strong>{{$t('You can close this window and continue buying Robux!')}}</strong>
            </div>
            <div class="gamepass-instruction" v-if="mode === 0">
                <h2>
                    {{$t('Manual: how to create a Game Pass in Roblox and set a price for it.')}}
                </h2>
                <p v-html="$t('Log in to your Roblox account on the website and select <strong>Create<strong> at the top.')"></p>
                <img src="/assets/img/roblox/instruction/pc/1.webp" alt="1">
                <p v-html="$t('Click on <strong>Creations</strong> in the menu on the left.')"></p>
                <p v-html="$t('Next you need to select the Place in which to make the Game Pass. Make sure your Place is public - there\'s a green sign that says <strong>Public<strong>.')"></p>
                <img src="/assets/img/roblox/instruction/pc/2.webp" alt="2">
                <RobloxInstructiionAccordion class="mb-5">
                    <template #question>
                        {{$t('Click here if you have it says Private instead of Public.')}}
                    </template>
                    <template #answer>
                        <p v-html="$t('If it says Private under the name of the Place, click on the <strong>circle with 3</strong> dots in the upper right corner of the Place picture.')">
                        </p>
                        <img src="/assets/img/roblox/instruction/mobile/6.webp" alt="6">
                        <p v-html="$t('In the drop down menu, click <strong>Make Public</strong>.')"></p>
                        <img src="/assets/img/roblox/instruction/mobile/7.webp" alt="7">
                    </template>
                </RobloxInstructiionAccordion>
                <p v-html="$t('If it says Public under the Place’s name, click on the <strong>Place<strong> itself.')"></p>
                <img src="/assets/img/roblox/instruction/pc/3.webp" alt="3">
                <p v-html="$t('On the page that opens, choose <strong>Monetization</strong> from the menu on the left.')"></p>
                <img src="/assets/img/roblox/instruction/pc/4.webp" alt="4">
                <p v-html="$t('Next click <strong>Passes</strong>.')"></p>
                <img src="/assets/img/roblox/instruction/pc/5.webp" alt="5">
                <p v-html="$t('Next click <strong>Create A Pass</strong>.')"></p>
                <img src="/assets/img/roblox/instruction/pc/6.webp" alt="6">
                <p v-html="$t('Then enter any name of the pass in the <strong>Name</strong> field. It is not necessary to fill in the Description field. And click <strong>Create Pass</strong>.')"></p>
                <img src="/assets/img/roblox/instruction/pc/7.webp" alt="7">
                <p v-html="$t('In the list of your gamepasses find the created pass. And click <strong>on it</strong>.')"></p>
                <img src="/assets/img/roblox/instruction/pc/8.webp" alt="8">
                <p v-html="$t('In the menu on the left, select <strong>Sales</strong>.')"></p>
                <p v-html="$t('Toggle the <strong>Item for Sale</strong> slider to turn blue, and under the Default Price field, be sure to uncheck <strong>Enable regional pricing</strong>.')"></p>
                <img src="/assets/img/roblox/instruction/pc/9.webp" alt="9">
                <p v-html="$t('In the <strong>Default Price</strong> field, set the price we specified and click <strong>Save Changes</strong>.')"></p>
                <img src="/assets/img/roblox/instruction/pc/10.webp" alt="10">
                <p v-html="$t('Basically, everything is ready. But you can double-check yourself: in the list of your passes for the created pass, check the <strong<Current Price</strong>, and in the <strong<Regional Pricing</strong< column it should be Disabled.')"></p>
                <img src="/assets/img/roblox/instruction/pc/11.webp" alt="11">
                <p>{{$t(`That's it for sure now!`)}}</p>
                <strong>{{$t('You can close this window and continue buying Robux!')}}</strong>
            </div>
        </div>
    </Modal>
</template>
<style lang="css">
.gamepass-instruction {
    height: 100%;
    overflow-y: scroll;
}
.gamepass-instruction > h2 {
    font-family: "Fira Sans", sans-serif;
    font-size: 20px;
    font-weight: 500;
    color: black;
    padding-inline: 10px;
    margin-bottom: 20px;
}

.gamepass-instruction > p {
    font-family: "Fira Sans", sans-serif;
    font-size: 18px;
    color: black;
    padding-inline: 10px;
    margin-bottom: 20px;
}

.gamepass-instruction > strong {
    font-family: "Fira Sans", sans-serif;
    font-size: 18px;
    font-weight: 700;
    color: black;
    padding-inline: 10px;
    margin-bottom: 20px;
}

.gamepass-instruction > img {
    width: 100%;
    height: auto;
    margin-bottom: 20px;
}

.gamepass-instruction-accordion > img {
    max-width: 350px;
    width: 100%;
    margin: auto;
}
</style>
